<template>
    <h1
        :class="
            twMerge(
                'whitespace-nowrap text-left text-[30vw] font-bold tracking-wider text-base-white sm:text-[17.2vw] lg:text-[10vw]',
                $attrs.class,
            )
        "
    >
        <slot />
    </h1>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
</script>
